import React, {useState} from "react";
import {Card, Row, Table} from "antd";
import {Link} from "react-router-dom";
import {CourierTerminalHistoryTabFilters} from "./CourierTerminalHistoryTabFilters";
import {useStore} from "../../../../../hooks/useStore";
import {useFetch} from "../../../../../hooks/useFetch";
import {formatMomentDate} from "../../../../../utils/helpers";
import {ResponsiveDataTable} from "components/_defaultComponents/ResponsiveDataTable";

const PAGE_SIZE = 10;

export const CourierTerminalHistoryTab = ({isTabOpened}) => {
    const stores = useStore();
    const [filters, setFilters] = useState({});
    const [page, setPage] = useState(1);

    const [loading, terminals] = useFetch({
        fetchFn: stores.codPaymentStore.listCourierTerminals.bind(null, {
            ...filters,
            skip: (page - 1) * PAGE_SIZE,
            limit: PAGE_SIZE
        }),
        dependencies: [filters, page, isTabOpened],
        condition: isTabOpened,
        initialCall: true
    });

    const columns = [
        {
            title: "Serial No",
            dataIndex: "serialNo",
            key: "serialNo",
            onCell: () => ({
                "data-label": "Serial No"
            })
        },
        {
            title: "Terminal Id",
            dataIndex: "terminalId",
            key: "terminalId",
            onCell: () => ({
                "data-label": "Terminal Id"
            })
        },
        {
            title: "Kurye",
            dataIndex: ["courier", "fullname"],
            key: "courier",
            render: (fullname, row) =>
                row?.courier ? (
                    stores.meStore.checkRole("notVisibleForCompanyUser") ? (
                        <Link
                            target="_blank"
                            to={{
                                pathname: "/couriers/" + row?.courier?._id
                            }}
                        >
                            {row?.courier?.fullname}
                        </Link>
                    ) : (
                        row?.courier?.fullname ?? "Kurye"
                    )
                ) : (
                    "-"
                ),
            onCell: () => ({
                "data-label": "Kurye"
            })
        },
        {
            title: "Atanma Tarihi",
            dataIndex: "createdAt",
            key: "createdAt",
            render: createdAt => formatMomentDate(createdAt),
            onCell: () => ({
                "data-label": "Atanma Tarihi"
            })
        },
        {
            title: "Son Güncelleme Tarihi",
            dataIndex: "updatedAt",
            key: "updatedAt",
            render: updatedAt => formatMomentDate(updatedAt),
            onCell: () => ({
                "data-label": "Son Güncelleme Tarihi"
            })
        },
        {
            title: "Güncelleyen",
            dataIndex: ["updatedUser", "fullName"],
            key: "updatedUser",
            onCell: () => ({
                "data-label": "Güncelleyen"
            })
        },
        {
            title: "Terminal Durumu",
            dataIndex: "isActive",
            key: "isActive",
            render: isActive => (isActive ? "Aktif" : "Pasif"),
            onCell: () => ({
                "data-label": "Terminal Durumu"
            })
        }
    ];

    return (
        <Card>
            <Row gutter={[16, 16]} style={{marginBottom: 16}}>
                <CourierTerminalHistoryTabFilters filters={filters} setFilters={setFilters} />
            </Row>
            <ResponsiveDataTable
                loading={loading}
                columns={columns}
                size="small"
                dataSource={terminals?.rows || []}
                rowKey="_id"
                pagination={{
                    total: terminals?.dataCount || 0,
                    current: page,
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                    pageSize: PAGE_SIZE,
                    onChange: page => {
                        setPage(page);
                    }
                }}
            />
        </Card>
    );
};
